<template>
    <v-container>
        <h2>署名方式</h2>
        <div 
            class="pt-2 pl-2"
            style="font-size: 1.7rem!important"
        >
            {{ getSignatureMethodText(signatureMethod) }}
        </div>
    </v-container>
</template>

<script>
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
    export default {
        props: [
            'signatureMethod'
        ],
        mixins:[
            signatureMethodMixin
        ],
    };
</script>